import React from 'react';
import PropTypes from 'prop-types';

const DoubleBedBedroom = ({ color = '#66D5FF', outlineColor = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={64} height={37} viewBox="0 0 64 37" fill="none" {...props}>
    <path fill={color} d="M45.445 16.158h-9.23v13.384h9.23V16.158Z" />
    <path
      fill={outlineColor}
      d="M42.676 19.389a.923.923 0 1 0 0-1.847.923.923 0 0 0 0 1.846ZM36.215 9.235h2.769v3.692a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923V9.235h2.77a.92.92 0 0 0 .908-1.096L43.12.753A.924.924 0 0 0 42.215 0h-4.616a.92.92 0 0 0-.907.754l-1.385 7.384c-.05.27.023.55.196.762a.919.919 0 0 0 .712.335Zm2.15-7.385h3.084l1.039 5.538h-5.162l1.039-5.538Z"
    />
    <path
      fill={outlineColor}
      d="M62.984 14.773H57.28a2.8 2.8 0 0 0-.654-1.035 2.826 2.826 0 0 0-1.97-.811h-2.73a2.8 2.8 0 0 0-1.97.815 2.792 2.792 0 0 0-.65 1.031H34.369a.92.92 0 0 0-.923.923.92.92 0 0 0 .923.923h.923v5.539a.92.92 0 0 0 .924.923.92.92 0 0 0 .923-.923v-5.539h7.384v11.077h-5.538a.92.92 0 0 0-.923.923.92.92 0 0 0 .923.923h5.538v1.039a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923V16.619h2.77v13.846a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923v-6.461h4.615v6.461a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923V16.62h2.77v13.846a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923V16.62h.923a.921.921 0 0 0 .923-.923.921.921 0 0 0-.923-.923Zm-12 .942a.944.944 0 0 1 .942-.938h2.73c.247 0 .493.1.67.273a.937.937 0 0 1 .273.665v2.75h-4.615v-2.75Zm0 6.443V20.31h4.615v1.847h-4.615Z"
    />
    <path fill="#fff" d="M37 29.409H1v7h36v-7Z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M16 22.409H8c-1.102 0-2 1.346-2 3h9.997v-3H16ZM31 22.409h-8.8c-1.213 0-2.2 1.346-2.2 3h10.997v-3H31Z"
      clipRule="evenodd"
    />
    <path fill={color} d="M37 30H2v5h35v-5Z" />
    <path
      fill={color}
      fillRule="evenodd"
      d="M29 18H8v3.466l8.167-.036.582 2.57h3.502l.582-2.57H29V18Z"
      clipRule="evenodd"
    />
    <path
      fill={outlineColor}
      d="M2.003 26.224c0 .429.273.776.61.776.337 0 .61-.347.61-.776 0-.858.55-1.557 1.223-1.557h28.111c.674 0 1.223.699 1.223 1.557 0 .429.273.776.61.776.337 0 .61-.347.61-.776 0-1.716-1.098-3.114-2.446-3.114h-.916c0-.824-.263-1.626-.715-2.196-.451-.584-1.081-.914-1.728-.914h-7.334c-1.348 0-2.446 1.398-2.446 3.114h-2.14c0-.824-.262-1.626-.714-2.196-.451-.583-1.081-.914-1.728-.914H7.498c-.647 0-1.277.335-1.725.91-.458.574-.717 1.376-.717 2.2h-.61C3.098 23.114 2 24.512 2 26.228l.003-.004Zm19.861-4.667h7.334c.324 0 .637.167.866.459.226.287.357.686.357 1.098h-9.777c0-.858.55-1.557 1.223-1.557h-.003Zm-15.225.455c.226-.288.54-.455.863-.455h7.334c.324 0 .637.167.866.459.226.287.357.686.357 1.098H6.282c0-.412.131-.81.36-1.102H6.64ZM7.604 16c-.334 0-.604.335-.604.749v1.502c0 .414.27.749.604.749.334 0 .604-.335.604-.749h20.584c0 .414.27.749.604.749.334 0 .604-.335.604-.749v-1.502c0-.414-.27-.749-.604-.749-.334 0-.604.086-.604.5H8.208c0-.414-.27-.5-.604-.5Z"
    />
    <path
      fill={outlineColor}
      d="M36.404 25c-.404 0-1.018-.095-1.018.656v1.973H1.356V25.655C1.355 25 .924 25 .595 25c-.33 0-.596.294-.596.656v10.688c0 .362 0 .656.596.656.475 0 .76 0 .76-.656v-.823H35.5v.823c0 .656.5.656.904.656.33 0 .596-.294.596-.656V25.656c0-.362-.191-.656-.596-.656ZM1.355 29.091H35.5v4.5H1.355v-4.5Z"
    />
  </svg>
);

DoubleBedBedroom.propTypes = {
  color: PropTypes.string,
  outlineColor: PropTypes.string
};

export default DoubleBedBedroom;
